// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"65f68385","56":"0ddeec26","142":"647ffbf8","280":"31d6cfe0","347":"7f4e3cbd","357":"57b108f4","429":"06f456de","489":"a9ff48fe","596":"487c6b07","854":"033d98b7","855":"a8533449","868":"91c50b80","955":"31b7021f"}[chunkId] + ".chunk.css";
};